<template lang="pug">
div
  b-card
    .row
      .col-md-12
        .white-box
          h1.box-title.m-b-0 トップページレイヤー編集
          p.text-muted.m-b-30.font-13 SWAN Proサイトのトップページレイヤー編集画面
          div.form-horizontal
            .form-group
              label.col-md-12 言語
              .col-md-12
                el-select(v-model='formdata.locale', disabled='')
                  el-option(value='ja', label='日本語')
                  el-option(value='en', label='英語')
                  el-option(value='cn', label='中国語')
                  el-option(value='kr', label='韓国語')
            .form-group
              label(for='他の言語').col-md-12 他の言語 
              .col-md-12
                a(v-if="formdata.locale!='ja'" :href='locale_url.ja' replace) 日本語&nbsp;&nbsp;
                a(v-if="formdata.locale!='en'" :href='locale_url.en' replace) 英語&nbsp;&nbsp;
                a(v-if="formdata.locale!='cn'" :href='locale_url.cn' replace) 中国語&nbsp;&nbsp;
                a(v-if="formdata.locale!='kr'" :href='locale_url.kr' replace) 韓国語&nbsp;&nbsp;
            .form-group
              label.col-md-12 タイトル
              .col-md-12
                el-input(type='text', v-model='formdata.title')
            .form-group
              label.col-md-12 レイヤー種別
              .col-md-12
                el-radio-group(v-model='formdata.layer_type')
                  el-radio(label="text", border) テキスト 
                  el-radio(label="image_white", border) 画像（背景白）
                  el-radio(label="image_black", border) 画像（背景黒）
                  el-radio(label="video", border) 動画
              .form-group(v-if="formdata.layer_type=='image_white' || formdata.layer_type=='image_black'")
                .form-group(v-if='savedImageLength')
                  label.col-md-12 画像
                  .col-md-12
                    el-table(:data='formdata.images',key='imageTable')
                      el-table-column(label="image", width="300")
                        template(slot-scope="scope")
                          img(:src='scope.row.image_url', height='128')
                      el-table-column(property='image_url', label='image_url', width='500')
                      el-table-column(label='')
                        template(slot-scope='scope')
                          el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteConfirm(scope.$index)')
                .form-group(v-if='uploadedImagesLength')
                  label.col-md-12 画像
                  el-button(style='margin-left:18px', type='primary', icon='el-icon-plus', size='mini', @click='onBtnFileAdd', v-if='uploaded_images_arr.length === 0')
                  .col-md-12
                    el-table(:data='formdata.uploadedImages',key='upImageTable')
                      el-table-column(label='image', width='300')
                        template(slot-scope='scope')
                          img(:src='scope.row.image', height='128')
                      el-table-column(property='name', label='name', width='500')
                      el-table-column(label='')
                        template(slot-scope='scope')
                          el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteSubConfirm(scope.$index)') 
                  input#btnFileAdd(type='file', style='visibility: hidden', @change='onFileAdd($event)', accept='image/*')
              .form-group(v-if="formdata.layer_type=='video'")
                .form-group(v-if='savedVideoLength')
                  label.col-md-12 動画
                  .col-md-12
                    el-table(:data='formdata.videos',key='videoTable')
                      el-table-column(label='image', width='300')
                        template(slot-scope='scope')
                          img(:src='scope.row.thumb_url', height='128')
                      el-table-column(property='video_url', label='video_url', width='500')
                      el-table-column(label='')
                        template(slot-scope='scope')
                          el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteVideoConfirm(scope.$index)')
                .form-group(v-if="uploadedVideosLength")
                  label.col-md-12 動画
                  el-button(style='margin-left:18px', type='primary', icon='el-icon-plus', size='mini', @click='onVideoBtnFileAdd', v-if='uploaded_video_arr.length === 0')
                  .col-md-12
                    el-table(:data='formdata.uploadedVideos',key='videoUpTable')
                      el-table-column(property='name', label='name', width='500')
                      el-table-column(label='')
                        template(slot-scope='scope')
                          el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteVideoSubConfirm(scope.$index)')
                  input#btnVideoFileAdd(type='file', style='visibility: hidden', @change='onVideoFileAdd($event)', accept='video/*')
            Parameter(v-if="formdata.layer_type=='image_white' || formdata.layer_type=='image_black'",:value='formdata.layer_params')
            VideoParameter(v-if="formdata.layer_type=='video'",:value='formdata.layer_params')
            TextParameter(v-if="formdata.layer_type=='text'",:value='formdata.layer_params')
            .form-group
              label.col-md-12 状態
              .col-md-12
                el-select(v-model='formdata.status')
                  el-option(value='draft', label='編集中')
                  el-option(value='open', label='公開')
            .form-group
              el-button(@click='register', type='primary') 登録
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Parameter from './parameter'
import VideoParameter from './VideoParameter'
import TextParameter from './TextParameter'
export default {
  name: 'LayerEdit',
  data () {
    return {
      uploaded_images_arr: [],
      uploaded_video_arr: [],
      locale_url: {
        ja: '',
        en: '',
        cn: '',
        kr: ''
      },
      formdata: {
        entry_id: '',
        locale: '',
        layer_title: '',
        layer_type: '',
        layer_image_title: '',
        layer_image_url: '',
        layer_video_title: '',
        layer_video_url: '',
        images: [],
        uploadedImages: [],
        videos: [],
        uploadedVideos: [],
        layer_params: {
          'data-frames': '',
          'data-x': '',
          'data-y': '',
          'data-hoffset': '',
          'data-voffset': '',
          'data-width': '',
          'data-height': '',
          'data-basealign': '',
          'data-visibility': '',
          'data-videomp4': '',
          'data-videopreload': '',
          'data-volume': '',
          'data-forcerewind': '',
          'data-nextslideatend': '',
          'data-videoloop': '',
          'data-videowidth': '',
          'data-videoheight': '',
          'data-forceCover': '',
          'data-aspectratio': '',
          'data-autoplay': '',
          'data-autoplayonlyfirsttime': '',
          'data-fontsize': '',
          'data-lineheight': '',
          'data-whitespace': '',
          'data-type': '',
          'data-responsive_offset': '',
          'data-textAlign': '',
          'data-paddingtop': '',
          'data-paddingright': '',
          'data-paddingbottom': '',
          'data-paddingleft': '',
          'data-style': '',
          'image_width': '',
          'image_height': '',
          'image_alt': ''
        },
        layer_html: '',
        status: ''
      }
    }
  },
  created () {
    moment.locale('ja')
    this.imageLength = 0
    this.savedImageLength = false
    this.uploadedImagesLength = false
    this.savedVideoLength = false
    this.uploadedVideosLength = false

    if (this.$route.query.id && this.$route.query.locale) {
      this.getlayer(this.$route.query.id, this.$route.query.locale)
    } else {
      this.formdata.locale = 'ja'
      this.uploadedImagesLength = true
      this.uploadedVideosLength = true
    }
    this.locale_url.ja = '?id=' + this.$route.query.id + '&locale=ja'
    this.locale_url.en = '?id=' + this.$route.query.id + '&locale=en'
    this.locale_url.cn = '?id=' + this.$route.query.id + '&locale=cn'
    this.locale_url.kr = '?id=' + this.$route.query.id + '&locale=kr'
  },
  components: {
    Parameter,
    VideoParameter,
    TextParameter
  },
  methods: {
    getlayer (id, locale) {
      return axios({
        method: 'GET',
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/top_layer/edit?entry_id=' + id + '&locale=' + locale
      })
        .then((res) => {
          if (Object.keys(res.data).length) {
            let content = res.data
            this.formdata = content
            this.formdata.uploadedImages = []
            this.formdata.uploadedVideos = []
            if (this.formdata.images.length > 0 && this.formdata.images[0].image_url !== '') {
              this.savedImageLength = true
            } else {
              this.uploadedImagesLength = true
            }
            if (this.formdata.videos.length > 0 && this.formdata.videos[0].video_url !== '') {
              this.savedVideoLength = true
            } else {
              this.uploadedVideosLength = true
            }
          } else {
            this.formdata.entry_id = id
            this.formdata.locale = locale
            this.uploadedImagesLength = true
            this.uploadedVideosLength = true
            this.formdata.uploadedImages = []
            this.formdata.uploadedVideos = []
          }
        })
        .catch((error) => {
          this.formdata.entry_id = id
          this.formdata.locale = locale
          this.uploadedImagesLength = true
          this.uploadedVideosLength = true
          this.formdata.uploadedImages = []
          this.formdata.uploadedVideos = []
          console.log(error)
        })
    },
    deleteConfirm (index) {
      this.$confirm('削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formdata.images.splice(index, 1)
        this.savedImageLength = false
        this.uploadedImagesLength = true
        this.formdata.uploadedImages = []
        this.uploaded_images_arr = []
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    deleteSubConfirm (index) {
      this.$confirm('削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formdata.uploadedImages.splice(index, 1)
        this.uploaded_images_arr = []
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    deleteVideoConfirm (index) {
      this.$confirm('削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formdata.videos.splice(index, 1)
        this.savedVideoLength = false
        this.uploadedVideosLength = true
        this.formdata.uploadedVideos = []
        this.uploaded_videos_arr = []
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    deleteVideoSubConfirm (index) {
      this.$confirm('削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formdata.uploadedVideos.splice(index, 1)
        this.uploaded_videos_arr = []
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    onFileAdd (e) {
      let files = e.target.files || e.dataTransfer.files
      if (files[0].type.match(/image/i)) {
        let reader = new FileReader()
        reader.onload = (r) => {
          this.formdata.uploadedImages.push({ name: files[0].name, image: r.target.result, caption: '' })
        }
        reader.readAsDataURL(files[0])
        this.uploaded_images_arr.push(files[0].name)
      } else {
        let msg = '画像ではありません'
        alert(msg)
      }
    },
    onVideoFileAdd (e) {
      let files = e.target.files || e.dataTransfer.files
      if (files[0].type.match(/video/i)) {
        let reader = new FileReader()
        reader.onload = (r) => {
          this.formdata.uploadedVideos.push({ name: files[0].name, image: r.target.result, caption: '' })
        }
        reader.readAsDataURL(files[0])
      } else {
        let msg = '動画ではありません'
        alert(msg)
      }
    },
    onBtnFileAdd (e) {
      document.getElementById('btnFileAdd').click()
    },
    onVideoBtnFileAdd (e) {
      document.getElementById('btnVideoFileAdd').click()
    },
    register: function () {
      let inputData = JSON.stringify(this.formdata)
      console.log(inputData)
      axios({
        baseURL: process.env.API_BASE_URL,
        url: '/admin/swan/top_layer/edit',
        method: 'POST',
        data: {
          data: inputData
        }
      })
        .then((response) => {
          this.$message({
            type: 'success',
            message: 'completed'
          })
        })
        .catch((error) => {
          this.$message({
            type: 'info',
            message: 'no completed'
          })
          console.log(error)
        })
    }
  }
}
</script>

<style lang='scss' scoped>
*:focus {
  outline: 0
}
</style>


// WEBPACK FOOTER //
// src/views/components/swan/layer/edit.vue